import { assoc, compose, map, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { formsClient } from '../../../../utils/apollo/api'

const cleanRequest = form =>
  map(
    compose(
      pick(['checklistId', 'name', 'description', 'access', 'validationPlaceFieldId', 'id', 'placeType']),
      item =>
        assoc('validationPlaceFieldId', (item?.validationRequired && item?.validationPlaceField?.id) || null)(item),
      item => assoc('checklistId', item?.checklist?.id)(item)
    )
  )(form)

const validate = (forms, setErrors, t) => {
  const errors = forms.reduce(
    (errors, item, index) => [
      ...errors,
      ...appendIf(!item.name, { path: [index, 'name'], message: t('validations:required') }),
      ...appendIf(!item.description, { path: [index, 'description'], message: t('validations:required') }),
      ...appendIf(!item.checklist?.id, { path: [index, 'checklist'], message: t('validations:required') }),
      ...appendIf(!item.access, { path: [index, 'access'], message: t('validations:required') })
    ],
    []
  )

  setErrors(errors)
  return errors.length === 0
}

const MUTATION = gql`
  mutation UpsertForms($inputs: [FormInput]) {
    upsertForms(inputs: $inputs) {
      id
    }
  }
`

export const useSaveForms = () => {
  const { t } = useTranslation('validations')
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Forms'], client: formsClient })

  const handleRequest = (forms, actions) => {
    const inputs = cleanRequest(forms)
    const { setErrors } = actions
    const isValid = validate(forms, setErrors, t)

    if (isValid) {
      return request({ variables: { inputs } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
